import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	Input,
	ViewChild,
	OnInit,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { openClose } from '@core/animations/animations';
import { buildDetailsInformation } from '@core/util/mortgage';
import { BusinessUser } from '@models/businesses';
import {
	MatterMortgage,
	MatterMortgageWithAssociations,
} from '@models/mortgage';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterMortgagesState } from '@state/matter/matter_mortgages';
import { Observable } from 'rxjs';
import { CloserSyncRFFComponent } from '../closer-sync-rff/closer-sync-rff.component';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MortgageDetailsOverview } from '../../mortgages.models';
import { MatterMortgageFormTemplatesState } from '@state/matter/matter_mortgages/matter-mortgage-forms/matter-mortgage-form-templates.state';
import { MortgageTabOption } from '../../llc/components/mortgage-tabs/mortgage-tabs.component';

export enum DetailNavType {
	MORTGAGE_DETAILS = 'mortgageDetails',
	LENDER_DETAILS = 'lenderDetails',
	PAYMENT = 'payment',
	REPORTING_INFORMATION = 'reportingInformation',
	DOCUMENTS = 'documents',
}

const DetailsNavOptions: MortgageTabOption<DetailNavType>[] = [
	{
		label: 'General Details',
		value: DetailNavType.MORTGAGE_DETAILS,
		intercomAttr: 'closer-sync-mortgage-tabs-general',
	},
	{
		label: 'Terms & Payment',
		value: DetailNavType.PAYMENT,
		intercomAttr: 'closer-sync-mortgage-tabs-payment',
	},
	{
		label: 'Registration Details',
		value: DetailNavType.REPORTING_INFORMATION,
		intercomAttr: 'closer-sync-mortgage-tabs-reporting',
	},
	{
		label: 'Forms',
		value: DetailNavType.DOCUMENTS,
		intercomAttr: 'closer-sync-mortgage-tabs-document',
	},
];

@UntilDestroy()
@Component({
	selector: 'app-closer-sync-mortgage',
	templateUrl: './closer-sync-mortgage.component.html',
	styleUrls: ['./closer-sync-mortgage.component.scss'],
	animations: [openClose()],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CloserSyncMortgageComponent implements OnInit {
	public _matterMortgage: MatterMortgageWithAssociations;
	public _mortgage: MatterMortgageWithAssociations;
	public details: MortgageDetailsOverview;

	public selected = DetailNavType.MORTGAGE_DETAILS;
	public detailsNavOptions = DetailsNavOptions;
	public detailNavTypes = DetailNavType;

	public TAB_SELECT_OPTIONS = DetailNavType;

	@Input() set matterMortgage(matterMortgage: MatterMortgageWithAssociations) {
		this._matterMortgage = matterMortgage;
	}
	@SelectSnapshot(MatterMortgagesState.getSelectedMortgage)
	mortgage: MatterMortgage;
	@Select(SelectedMatter.assignedLawyerUser)
	assignedLawyer$: Observable<BusinessUser>;
	@ViewChild('mortgageTabs', { static: true, read: ElementRef })
	mortgageTabs: ElementRef;
	@Select(MatterMortgageFormTemplatesState.hasNewFlaggedMortgageFormSync)
	hasNewMortgageForm$: Observable<boolean>;

	constructor(
		private modalDialog: MatDialog,
		private changeDetectorRef: ChangeDetectorRef,
		private route: ActivatedRoute,
	) {}

	ngOnInit() {
		this.details = buildDetailsInformation(
			this.mortgage as MatterMortgageWithAssociations,
		);

		this.route.queryParams.pipe(untilDestroyed(this)).subscribe((params) => {
			if (params.page) {
				this.gotoArea(params.page);
			}
		});

		this.hasNewMortgageForm$.pipe(untilDestroyed(this)).subscribe((hasNew) => {
			const newDetailsNavOptions = this.detailsNavOptions.map((tab) => {
				if (tab.value === DetailNavType.DOCUMENTS) {
					tab.newFlag = hasNew;
				}
				return tab;
			});
			this.detailsNavOptions = newDetailsNavOptions;
		});
	}

	viewAmendments() {
		// const data: AmendmentModalData = {
		// 	transaction: this._mortgage,
		// };
		// this.dialog.open(LLCAmendmentsModalComponent, { data });
		console.log('Method not implemented. forcing a rebuild.');
	}

	submitRequestForFunds() {
		this.modalDialog.open(CloserSyncRFFComponent, {
			width: '80vw',
		});
	}

	updateSelectedTab(tab: DetailNavType) {
		this.selected = tab;
		this.changeDetectorRef.detectChanges();
	}

	gotoArea(path: DetailNavType) {
		this.selected = path;
		this.mortgageTabs.nativeElement.scrollIntoView({ behavior: 'smooth' });
	}

	viewDocuments() {
		this.selected = DetailNavType.DOCUMENTS;
	}

	// fundMortgage() {
	// 	console.log('start');
	// 	const audio = new Audio('/assets/images/mortgage/shake.mp3');
	// 	audio.currentTime = 5;
	// 	audio.play();
	// 	setTimeout(() => {
	// 	console.log('fund');
	// 		this.funded = true;
	// 		this.changeDetectorRef.detectChanges();
	// 	}, 4500);
	// 	setTimeout(() => {
	// 	console.log('hype');
	// 		this.hype = true;
	// 		this.changeDetectorRef.detectChanges();
	// 	}, 6000);
	// 	setTimeout(() => {
	// 	console.log('stop');
	// 		audio.pause();
	// 		this.changeDetectorRef.detectChanges();
	// 	}, 10000);
	// }
}
